import Comment from '@/models/Comment';
import Trade from '@/models/Trade';
import TradeService from '@/services/TradeService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useTradesStore = defineStore('trades', {
  state: () => ({}),

  getters: {
    models: () => useRepo(Trade),
  },

  actions: {
    async fetchTrades(projectId: Id, form: ApiRequests['api.v1.trades.index']) {
      const [data, error] = await TradeService.index(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async createTrade(projectId: Id, form: ApiRequests['api.v1.trades.store']) {
      const [data, error] = await TradeService.create(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateTrade(id: Id, form: ApiRequests['api.v1.trades.update']) {
      const [data, error] = await TradeService.update(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateComment(tradeId: Id, commentId: Id, request: ApiRequests['api.v1.trades.comments.update']) {
      const [data, error] = await TradeService.updateComment(tradeId, commentId, request);

      if(error) {
        throw error;
      }

      useRepo(Comment).save(data);

      return data;
    },

    async updateSort(id: Id, form: ApiRequests['api.v1.trades.sort']) {
      const [data, error] = await TradeService.updateSort(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deleteTrade(id: Id) {
      const [data, error] = await TradeService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.trade.id);

      this.models.save(data.sort_order);

      return data;
    },

    async generateTrades(projectId: Id) {
      const [data, error] = await TradeService.seed(projectId);

      if(error) {
        throw error;
      }

      return data;
    },

    async updateBaselineForecast(id: Id, form: ApiRequests['api.v1.trades.baseline-forecast']) {
      const [data, error] = await TradeService.updateBaselineForecast(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateForecast(id: Id, form: ApiRequests['api.v1.trades.forecast']) {
      const [data, error] = await TradeService.updateForecast(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
